import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useAuth } from '../AuthContext';

const PrivateLogin: React.FC = () => {
  const { urlId } = useParams<{ urlId: string }>();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!urlId) {
      setError('Invalid URL');
      return;
    }

    setLoading(true);
    try {
      await login(urlId, password);
      navigate('/home');
    } catch (err: any) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', py: 4 }}>
        <Paper sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <LockIcon sx={{ fontSize: 32, color: "primary.main" }} />
          </Box>

          <Typography variant="h4" gutterBottom align="center" fontWeight="bold">
            Welcome Back
          </Typography>

          <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 1 }}>
            Private URL:
          </Typography>

          <Typography
            variant="body1"
            align="center"
            sx={{
              fontFamily: 'monospace',
              color: "primary.main",
              fontWeight: 'bold',
              mb: 3,
            }}
          >
            {urlId}
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              type="password"
              label="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              autoFocus
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              disabled={loading}
              sx={{
                mt: 3,
              }}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </Button>

            <Button
              variant="text"
              fullWidth
              onClick={() => navigate('/')}
              sx={{ mt: 2 }}
            >
              Back to Home
            </Button>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default PrivateLogin;
